import { ProCard, ProDescriptions } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { CostCarrierEditDrawer } from '@app/icare/entities/costCarrier/edits/CostCarrierEditDrawer'
import { t } from '@lingui/core/macro'
import { EditSectionButton } from '@pkg/ui/button'
import { TypedDescriptionsItem } from '@pkg/ui/proValueTypes'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Flex } from 'antd'

export const Route = createFileRoute('/_app/kostentrager/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const { data } = useQuery(localQueryEntityOptions(params.id))

  if (!data) {
    return <ProCard loading />
  }

  return (
    <Flex vertical gap="middle">
      <ProCard
        title={t`Allgemein`}
        extra={
          <EditSectionButton onClick={() => void CostCarrierEditDrawer.show({ id: params.id, section: 'general' })} />
        }
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Name`}>{data.name}</TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`IK-Nummer`}>{data.ikNumber.main?.ikNumber}</TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Zusatz`}>{data.name}</TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Adresse`} valueType="mapsLink">
            {data.address}
          </TypedDescriptionsItem>
        </ProDescriptions>
      </ProCard>
      <ProCard
        title={t`Kontakt`}
        extra={
          <EditSectionButton onClick={() => void CostCarrierEditDrawer.show({ id: params.id, section: 'contact' })} />
        }
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem valueType="phoneLink">{data.contact?.phone}</TypedDescriptionsItem>
          <TypedDescriptionsItem valueType="phoneLink">{data.contact?.mobile}</TypedDescriptionsItem>
          <TypedDescriptionsItem valueType="emailLink">{data.contact?.email}</TypedDescriptionsItem>
          <TypedDescriptionsItem valueType="faxLink">{data.contact?.fax}</TypedDescriptionsItem>
        </ProDescriptions>
      </ProCard>

      <ProCard
        headerBordered
        title={t`Sonstiges`}
        extra={
          <EditSectionButton onClick={() => void CostCarrierEditDrawer.show({ id: params.id, section: 'comment' })} />
        }
      >
        <TypedDescriptionsItem label={t`Bemerkung`}>{data.comment}</TypedDescriptionsItem>
      </ProCard>
    </Flex>
  )
}
